import "./styles.scss";

const LessonFooter = ({ message }) => <footer className="lessonFooter">{message}</footer>;

export default LessonFooter;
